import React from 'react';
import axios from 'axios';

import { useModal } from '../Components/Modal/ModalContext';
import { useTimeModal } from '../Components/TimeModal/TimeModalContext';

import HeadlinePanel from '../Components/HeadlinePanel';
import LoadingLines from '../Components/LoadingLines';
import WarningPanel from '../Components/WarningPanel';

import EditLPPModal from '../Components/ElementsOfUsersPage/EditLPPModal';

import styles from '../styles/TableContainers.module.css';
import headerPanel from '../styles/HeaderPanel.module.css';

import IconContainer from '../Components/IconContainer';
import { ReactComponent as PenIcon } from '../icons/pen.svg';
import { ReactComponent as TrashIcon } from '../icons/trash.svg';

export default function ProceduresEditor() {
    const { openModal } = useModal();
    const { openTimeModal } = useTimeModal();

    const [cases, setCases] = React.useState([]);
    const [warning, setWarning] = React.useState('');
    const [loading, setLoading] = React.useState(true);
    const [reload, setReload] = React.useState(true);

    const [isEditLPP, setIsEditLPP] = React.useState(false);
    const [currentLPPId, setCurrentLPPId] = React.useState('');
    const [currentAction, setCurrentAction] = React.useState('');
    const [currentType, setCurrentType] = React.useState('');

    React.useEffect(() => {
        axios.get('/api/categories-procedures-phases')
            .then(response => {
                if (response.data.length === 0) {
                    setWarning('Типы дел, категории и этапы отсутствуют в системе.');
                    setCases([]);
                } else {
                    const structuredData = response.data.map(category => {
                        return {
                            ...category,
                            procedures: category.procedures.map(procedure => {
                                return {
                                    ...procedure,
                                    phases: procedure.phases.sort((a, b) => a.order_of_phase - b.order_of_phase)
                                };
                            })
                        };
                    });
                    setWarning('');
                    setCases(structuredData);
                }
            })
            .catch(error => {
                console.error(error);
                setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
            })
            .finally(() => {
                setReload(false);
                setLoading(false);
            });
    }, [reload]);

    const deleteCategory = (id) => {
        axios.delete(`/api/delete-category?id=${id}`)
        .then(() => {
            setReload(true);
            openTimeModal(`Категория удалена`, 'success');
        })
        .catch((error) => {
            console.error(error);
            openTimeModal(`Не удалось удалить категорию. ${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`, 'error');
        });
    }
    const deleteProcedure = (id) => {
        axios.delete(`/api/delete-procedure?id=${id}`)
        .then(() => {
            setReload(true);
            openTimeModal('Процедура удалена', 'success');
        })
        .catch((error) => {
            openTimeModal(`Не удалось удалить процедуру. ${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`, 'error');
        });
    }
    const deletePhase = (id) => {
        axios.delete(`/api/delete-phase?id=${id}`)
        .then(() => {
            setReload(true);
            openTimeModal('Этап исполнения удалён', 'success');
        })
        .catch((error) => {
            console.error(error);
            openTimeModal(`Не удалось удалить этап исполнения. ${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`, 'error');
        });
    }

    const openSuperModal = (action, subject, id) => {
        setIsEditLPP(true);
        setCurrentLPPId(id);
        setCurrentType(subject);
        setCurrentAction(action);
    }

    return (
    <>
        {isEditLPP && <EditLPPModal closeModal={() => {setIsEditLPP(false)}} id={currentLPPId} type={currentType} action={currentAction} onDoSuccess={() => {setReload(true)}} />}

        <div className='mainContainer'>
            <HeadlinePanel label='Процедуры' type='На главную' />
            <div className='containerInner'>
                <div className={headerPanel.additionalPanel}>
                    <button type='button' className='button' onClick={() => {openSuperModal('add', 'category', '')}}>
                        <svg viewBox="0 0 24 24" id="plus" fill="currentColor">
                            <path d="M19,11H13V5a1,1,0,0,0-2,0v6H5a1,1,0,0,0,0,2h6v6a1,1,0,0,0,2,0V13h6a1,1,0,0,0,0-2Z"></path>
                        </svg>
                        Добавить новую категорию
                    </button>
                </div>
                <div className='pageWrapper'>
                        {loading ? <LoadingLines />
                        : warning ? <WarningPanel inTable={true} text={warning} buttonText='Обновить таблицу' buttonAction={() => setReload(true)} /> 
                            : cases.map((category, index) => (
                            <div className='tableContainer'>
                                <div className={styles.tableDescription} key={index}>
                                    <h2>{category.name}</h2>
                                    <span>
                                        <IconContainer Icon={PenIcon} onClick={() => {openSuperModal('change', 'category', category.id)}} size = '18' color = 'blue' className = '' />
                                        <IconContainer Icon={TrashIcon} onClick={() => {deleteCategory(category.id)}} size = '18' color = 'red' className = '' />
                                    </span>
                                </div>
                                {category.procedures.length > 0 ?
                                <>
                                    {category.procedures.map((procedure, index) => (
                                        <div className={styles.tableHeader} key={index}>
                                            <p>{procedure.name}</p>
                                            <span>
                                                <IconContainer Icon={PenIcon} onClick={() => {openSuperModal('change', 'procedure', procedure.id)}} size = '16' color = 'blue' className = '' />
                                                <IconContainer Icon={TrashIcon} onClick={() => {deleteProcedure(procedure.id)}} size = '16' color = 'red' className = '' />
                                            </span>
                                        </div>
                                    ))}
                                </>
                                :
                                    <div className={styles.tableLine}>
                                        <a>В данной категории нет ни одной процедуры</a>
                                    </div>
                                }
                                {
                                    <div className={styles.tableLine} style={{borderBottom: 'none'}}>
                                        <a className='button miniButton' style={{width: 'fit-content'}} onClick={() => {openSuperModal('add', 'procedure', category.id)}}>
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="plus"><path fill="black" d="M19,11H13V5a1,1,0,0,0-2,0v6H5a1,1,0,0,0,0,2h6v6a1,1,0,0,0,2,0V13h6a1,1,0,0,0,0-2Z"></path></svg>
                                            Добавить новую процедуру
                                        </a>
                                    </div>
                                }
                            </div>
                            ))
                        }
                </div>
            </div>
        </div>
    </>
    );
};
